function createPredicate(filterString) {
    var filterObj = JSON.parse(filterString);
    return function (obj) {
        if ((filterObj === null || filterObj === void 0 ? void 0 : filterObj.must) && !filterObj.must.every(function (condition) { return evaluateCondition(condition, obj); })) {
            return false;
        }
        if ((filterObj === null || filterObj === void 0 ? void 0 : filterObj.must_not) && filterObj.must_not.some(function (condition) { return evaluateCondition(condition, obj); })) {
            return false;
        }
        if ((filterObj === null || filterObj === void 0 ? void 0 : filterObj.should) && !filterObj.should.some(function (condition) { return evaluateCondition(condition, obj); })) {
            return false;
        }
        return true;
    };
}
function evaluateCondition(condition, obj) {
    if (condition.term) {
        for (var key in condition.term) {
            if (obj[key] !== condition.term[key])
                return false;
        }
    }
    if (condition.terms) {
        for (var key in condition.terms) {
            if (!condition.terms[key].includes(obj[key]))
                return false;
        }
    }
    return true;
}

export { createPredicate };
//# sourceMappingURL=condition.js.map
